import React, { FC } from "react";
import { FooterLink } from "../../../../types/types";
import { FooterLinkModel } from "../../../../lib/shared-models/FooterLink.model";
import "./styles.scss";
import { Link, RichText } from "@sitecore-jss/sitecore-jss-react";

const Navigation: FC<FooterLink> = (props) => {
  const model = new FooterLinkModel(props);

  const items = model.list.map((item: FooterLink, index: number) =>
    item.fields?.Link?.value?.href &&
    !item.fields?.IsCookiePolicyLink?.value ? (
      <li key={index} className="footer-navigation__item">
        <Link
          field={item.fields?.Link}
          className="footer-navigation__link"
        />
      </li>
    ) : (
      <li key={index} className="footer-navigation__item">
        <Link
          field={item.fields?.Title as any}
          href="javascript:Optanon.ToggleInfoDisplay()" //change needed this generates an error
          className="footer-navigation__link"
        >
          <RichText
            field={item.fields?.Title}
            className="footer-navigation__link"
          />
        </Link>
      </li>
    )
  );
  return <ul className="footer-navigation">{items}</ul>;
};

export default Navigation;
